import { useSelector } from 'react-redux'
import type { RootState } from 'shared/store/reducers'
import { useMemo } from 'react'
import {
    featureCodes,
    restaurantServices,
    restaurantStatus
} from 'shared/utils'

import type { TableStatusType } from './components/table-card/TableStatus'

export const useTableStatus = (terrace: boolean) => {
    const restaurant = useSelector(
        (s: RootState) => s.restaurantPageState.restaurant
    )
    const { available } = useSelector((state: RootState) => state.featuresState)

    return useMemo((): TableStatusType => {
        if (!restaurant) {
            return 'LOADING'
        }
        if (
            !restaurant.services.includes(restaurantServices.TABLE_ORDER) ||
            !available.includes(featureCodes.TABLE_ORDER)
        ) {
            return 'UNAVAILABLE'
        }
        if (restaurant.status === restaurantStatus.CLOSED) {
            return 'CLOSED'
        }
        if (restaurant.status === restaurantStatus.IMMINENT_OPENING) {
            return 'IMMINENT_OPENING'
        }
        if (
            !terrace &&
            !restaurant.services.includes(restaurantServices.TABLE_ORDER_INDOOR)
        ) {
            return 'INDOOR_CLOSED'
        }
        if (
            terrace &&
            !restaurant.services.includes(
                restaurantServices.TABLE_ORDER_OUTDOOR
            )
        ) {
            return 'OUTDOOR_CLOSED'
        }

        return 'SUCCESS'
    }, [restaurant, terrace, available])
}
